module.exports = __webpack_public_path__ + "img/empty.5286939c.png";